import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './css/fonts/index.css'
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './redux/store';
import { createBrowserHistory } from 'history';
import { Helmet } from 'react-helmet';


const history = createBrowserHistory();

let app = document.getElementById('root');
if (app) {
  const path = (/#!(\/.*)$/.exec(window.location.hash) || [])[1];
  if (path) {
    history.replace(path);
  }

  ReactDOM.render(
    <Provider store={store}>
      <Helmet>
        <script async src="https://www.googletagmanager.com/gtag/js?id=UA-163586645-1"></script>
      </Helmet>
      <App />
    </Provider>,
    document.getElementById('root')
  );
}
reportWebVitals();
